import apiBase from "../../api/axios";

/**
 * Listar eventos de agenda (filtrados por mes, búsqueda, ordenamiento)
 */
export const getAgendaEventsService = async ({
  mes = null,
  search = "",
  ordering = "-fecha_hora_inicio",
} = {}) => {
  let url = "v1/agenda/";
  const params = new URLSearchParams();

  if (mes) params.append("mes", mes);
  if (search) params.append("search", search);
  if (ordering) params.append("ordering", ordering);

  const queryString = params.toString();
  if (queryString) url += `?${queryString}`;

  const response = await apiBase.get(url);
  return response.data;
};

/**
 * Obtener detalle de un evento
 */
export const getAgendaEventByIdService = async (id) => {
  const response = await apiBase.get(`v1/agenda/${id}/`);
  return response.data;
};

/**
 * Crear un nuevo evento
 */
export const createAgendaEventService = async (payload) => {
  const response = await apiBase.post("v1/agenda/", payload);
  return response.data;
};

/**
 * Actualizar evento completo (PUT)
 */
export const updateAgendaEventService = async (id, payload) => {
  const response = await apiBase.put(`v1/agenda/${id}/`, payload);
  return response.data;
};

/**
 * Actualizar evento parcial (PATCH)
 */
export const patchAgendaEventService = async (id, payload) => {
  const response = await apiBase.patch(`v1/agenda/${id}/`, payload);
  return response.data;
};

/**
 * Eliminar evento (soft delete)
 */
export const deleteAgendaEventService = async (id) => {
  const response = await apiBase.delete(`v1/agenda/${id}/`);
  return response.data;
};

/**
 * Listar estudiantes asignados al mentor autenticado
 */
export const getMisEstudiantesService = async () => {
  const response = await apiBase.get("v1/agenda/mis-estudiantes/");
  return response.data;
};
